(function () {
	angular
		.module('trackeye')
		.factory('DeviceService', DeviceService);

	DeviceService.$inject = ['DeviceCollection', 'Device', 'OpenLayersService', 'HttpQueue', 'C4ApiService', 'NotificationService', '$localStorage', '$rootScope'];

	function DeviceService(DeviceCollection, Device, OpenLayersService, HttpQueue, api, NotificationService, $localStorage, $rootScope) {
		var collection = new DeviceCollection(),
			exports = {},
			callbacks = [];

		/**
		 * Instantiate a mock instance, so calls wont fail
		 * when the app is initializing.
		 */
		var selected = new Device({}, true),
			selected_message,
			is_initializing = false,
			ts_begin = new Date();

		exports.init = function (userAccount) {
			is_initializing = true;
			api.units().get({
				include: "owner,permissions,configurations"
			}, function(data) { initialize(userAccount, data) }, function(err) {
				is_initializing = false;
				console.warn(err);
				$rootScope.$broadcast('DeviceService.not-found');
			});
		};

		function initialize(account, data) {
			collection.initialize(account, data).then(function() {
				var devices = collection.sut();

				// Create feature/circles for every device.
				devices.forEach(function (device) {
					OpenLayersService.createCircle(device);
					OpenLayersService.createIcon(device);
				});

				unloaded = devices;

				var last_selected = $localStorage.last_selected;
					cached_device = exports.findOne(last_selected ? last_selected[0] : undefined),
					init_device = devices[0];

				if (cached_device) {
					exports.setSelectedDevice(cached_device);
				} else if (init_device) {
					exports.setSelectedDevice(init_device);
				}

				$rootScope.$broadcast('DeviceService.initialized');

				collection.watchForUpdates(function (latest_data) {
					latest_data.forEach(function(data) {
						var nodeid = data.unit.number,
							device = exports.find(nodeid);
						
						if (device) {
							device.updateLatestMessage(data);
						}
					});

					$rootScope.$broadcast('DeviceService.data');
				});
			}).finally(function() {
				var ts_end = new Date() - ts_begin;
				is_initializing = false;
				$rootScope.$broadcast('DeviceService.initialized');
				api.LogDEBUG('app_profile: units+latest loaded after '+ts_end+'ms');
			});
		}

		exports.isInitializing = function() {
			return is_initializing;
		}

		exports.add = function (nodeid) {
			return collection.postAdd(nodeid);
		};

		exports.find = function (nodeid) {
			return collection.find(nodeid);
		};
		
		exports.findOne = function (nodeid) {
			return collection.findOne(nodeid);
		};

		exports.hasSutDevices = function () {
			return !!exports.getSutDevices().length
		}

		/**
		 * @todo DeviceCollection should return the correct list of prepaid devices.
		 * @returns {Device[]}
		 */
		exports.getPrepaidDevices = function () {
			return collection.getPrepaidSut();
		};

		exports.hasRapidPoliceDevices = function () {
			var devices = collection.findBy('subscription', 21);
			return !!devices.find(function(device) {
				return device.features.isPoliceRapid();
			});
		}

		exports.getRapidPoliceDevices = function () {
			var police =  collection.findBy('subscription', 21);

			return police.filter(function(device) {
				return device.features.isPoliceRapid();
			});
		}

		exports.hasPrepaidDevices = function () {
			return collection.hasPrepaidDevices();
		};

		exports.hasPendingBatteryReplacement = function (device) {
			return false;
		};

		exports.updateDevice = function (device, data) {
			return api.units().save({id: device.id}, {
				name: data.name,
				description: data.description
			}, function () {
				device.setName(data.name);
			});
		};

		/**
		 * Update several devices, sequentially.
		 * @param {Device[]} devices
		 * @param {Object} data
		 * @param {Function} [callback]
		 * @returns {Promise}
		 */
		exports.batchUpdateDevices = function (devices, data, callback) {
			devices.forEach(function(device) {
				var defaults = {
						name: device.getName(),
						locale: device.getLocale()
					};

				HttpQueue.add('batch-update-devices', {
					url: api.getUrl('/units/'+device.getUuid()),
					method: 'PUT',
					data: angular.merge({}, defaults, data),
					__ignore_auth: true
				}).then(function(xhr) {
					if (typeof callback === "function") {
						callback(device, xhr);
					}
				})
			});

			return HttpQueue.promise('batch-update-devices');
		};

		exports.getConfig = function (device) {
			return api.configGet({
				guid: device.getGuid()
			});
		};
		/**
		 * Flush the list for all devices
		 */
		exports.flush = function () {
			collection.flush();
		};

		exports.prices = function (device) {
			return api.units().prices({nodeid: device.nodeid});
		};

		exports.getAppSubscription = function (device) {
			return api.units().appSubscription({nodeid: device.nodeid});
		};

		exports.recurringAppSubscription = function (device, recurring) {
			return api.units().recurringAppSubscription({
				nodeid: device.getNodeId(),
				recurring: recurring ? "1" : "0"
			}).$promise.then(function () {
				// @todo implement device refresh method
				if (recurring) {
					NotificationService.info("STR_NOTICE_RECURRING_FOR_DEVICE_ACTIVATED", {
						name: device.getName() || device.getNodeId()
					});
				} else {
					NotificationService.info("STR_NOTICE_RECURRING_FOR_DEVICE_DEACTIVATED", {
						name: device.getName() || device.getNodeId()
					});
				}
				device.initialize();
			});
		};

		/**
		 *
		 * @param {Account} account
		 * @param {Device} device
		 * @param {number} plan_id
		 * @returns {*|{method, url}}
		 */
		exports.startAppSubscription = function (account, device, plan_id) {
			var currentDate = new Date();

			currentDate.setHours(12);

			var data = {
					planId: plan_id,
					account_id: account.getId(),
					nodeid: device.getNodeId(),
					demoTo: device.demoTo.toISOString(),
					device_name: device.getName(),
					billing: {
						name: account.getName(),
						address: account.getStreet(),
						zipcity: account.getZip()+" "+account.getTown(),
						locale: account.getLocale()
					},
					date: currentDate.toISOString()
				},
				action = "start";

			if (device.hasAppSubscription()) {
				action = "renew";
			}

			return api.appSubscription(action, data);
		};

		exports.getDevicesByFleet = function (fleetName) {

		};

		exports.getFleets = function () {
			return collection.getFleets();
		};

		/**
		 * Set the currenct selected device
		 * @param {Device} new_device
		 * @returns {boolean}
		 */
		exports.setSelectedDevice = function (new_device) {
			if (!new_device)
				console.warn('Missing device instance!');

			/**
			 * Copy the callbacks, if the previous "selected" device
			 * was a mock.
			 */
			if (selected.isMock()) {
				new_device.callbacks = selected.callbacks;
			}

			new_device.postInitialize();

			if (!new_device.isLoaded()) {
				new_device.loadMessages();
			} else {
				new_device.sutmessages.resolvedAddressesCheck();
			}

			selected.deselect();

			new_device.setSelectedMessage(new_device.latest);
			selected = new_device;

			$rootScope.$broadcast('DeviceService.selected', new_device, selected);
			var last_selected = $localStorage.last_selected || [],
				nodeid = new_device.nodeid,
				last_index = last_selected.indexOf(nodeid);

			if (last_index >= 0) {
				nodeid = last_selected.splice(last_index, 1).pop();
			}

			last_selected.unshift(new_device.nodeid);
			if (last_selected.length > 9) {
				last_selected.length = 9;
			}
			$localStorage.last_selected = last_selected;

			fireCallbacks('selected', new_device);

			return true;
		};

		/**
		 * Return the current selected device or empty instance.
		 * Parse an optional callback, to be fired whenever the
		 * device instance is ready.
		 * @param {function} [callback]
		 * @returns {Device}
		 */
		exports.getSelectedDevice = function (callback) {
			if (callback) {
				addCallback('selected', callback);

				if (selected.isInitialized()) {
					callback(selected);
				}
			}

			return selected;
		};

		/**
		 * Sets passed message as selected.
		 * @param {SutMessage} message
		 */
		exports.setSelectedMessage = function (message) {
			selected.setSelectedMessage(message);
			selected_message = message;
		};

		/**
		 * Return the current selected device
		 * @returns {Device}
		 */
		exports.getSelectedMessage = function () {
			return selected.getSelectedMessage();
		};

		exports.getFilteredDevices = function () {
			return collection.filtered();
		};

		exports.getAllDevices = function () {
			return collection.all();
		};

		exports.getSutDevices = function () {
			return collection.sut();
		};

		exports.getOwnedSutDevices = function () {
			return collection.ownedSut();
		};

		exports.getNonSutDevices = function () {
			return collection.nonSut();
		};

		exports.verifyDevice = function (nodeid, code) {
			return api.verify_device({
				"number": nodeid,
				"code": code
			});
		};

		/**
		 * Add unit to account
		 * @returns {null}
		 */
		exports.claimDevice = function (nodeid, code) {
			return api.claim_device({
				"number": nodeid,
				"code": code
			});
		};

		function fireCallbacks (name, data) {
			callbacks.forEach(function (cb) {
				if (cb.name !== name)
					return;

				cb.fn(data);
			});
		}

		function addCallback (name, func) {
			callbacks.push({
				name: name,
				fn: func
			});
		}

		return exports;
	}
})();